module.exports = __webpack_public_path__ + "static/img/torsoScaled33.3754deb6.png";